import React, { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import ControlPanelButton from 'components/atoms/controlPanelButton';
import PcmIcon from 'components/atoms/icons/pcmIcon';
import { showResult } from 'utils';
import { API_PATIENTS_PCM_STATUS } from 'services/dataService/resources';
import dataService from 'services/dataService';
import { useDispatch } from 'react-redux';
import UpdatePatientPcmStatusModal from './modal';

const PatientPCMStatusButton = ({ profile }) => {
  const [popup, showPopup] = useState(false);
  const [loading, setLoading] = useState(false);
  const buttonRef = useRef();

  const {
    adminPanelPatients: { setPatientPcmStatus },
  } = useDispatch();

  const handleSubmit = async (value) => {
    const postData = { pcmStatus: value };
    setLoading(true);

    const { error, data } = await dataService.updateOnly(
      API_PATIENTS_PCM_STATUS(profile.guid),
      postData,
    );

    if (error) showResult(error);
    if (data) setPatientPcmStatus(value);

    setLoading(false);
  };

  return (
    <div
      className="admin-patient-header-actions-call patient-status"
      ref={buttonRef}
    >
      <ControlPanelButton
        label="PCM Status"
        icon={PcmIcon}
        disabled={loading}
        handleClick={() => showPopup(!popup)}
      />
      {popup && (
        <UpdatePatientPcmStatusModal
          togglePopup={showPopup}
          handleClick={handleSubmit}
        />
      )}
    </div>
  );
};

PatientPCMStatusButton.propTypes = {
  profile: PropTypes.shape({
    guid: PropTypes.string,
    title: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    covidStatus: PropTypes.string,
    status: PropTypes.string,
    birthDate: PropTypes.string,
  }),
};

export default PatientPCMStatusButton;
